export default __webpack_public_path__ + "static/media/Advanced Card Security Right.0ceb5858.png";